import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: string;
  className?: string;
}
export function PriceDisplay({
  amount,
  className = ''
}: PriceDisplayProps) {
  const [symbol, setSymbol] = useState('$');
  useEffect(() => {
    if (typeof navigator !== 'undefined') {
      const lang = navigator.language.toLowerCase();
      if (lang.includes('es-es')) {
        setSymbol('€');
      } else if (lang.includes('en-gb')) {
        setSymbol('£');
      } else {
        setSymbol('$');
      }
    }
  }, []);
  return <span className={className} data-id="element-279">
      {symbol}
      {amount}
    </span>;
}